<template>
  <div
    v-if="!isLoading && (sideDishes.length > 0 || companions.length > 0)"
    class="recipe-companions-container mt-4"
  >
    <!-- Side Dishes Section -->
    <div v-if="sideDishes.length > 0" class="mb-4">
      <h4 class="mb-3">Подходящие гарниры</h4>
      <div class="recipes-scroll-list">
        <RecipeCardPopular
          v-for="recipe in sideDishes"
          :key="recipe.id"
          :recipe="recipe"
          @show-full-recipe="handleShowFullRecipe"
        />
      </div>
    </div>

    <!-- Companions Section -->
    <div v-if="companions.length > 0">
      <h4 class="mb-3">С этим блюдом сочетается</h4>
      <div class="recipes-scroll-list">
        <RecipeCardPopular
          v-for="recipe in companions"
          :key="recipe.id"
          :recipe="recipe"
          @show-full-recipe="handleShowFullRecipe"
        />
      </div>
    </div>
  </div>
  <div v-else-if="isLoading" class="text-center mt-4">
    <div class="spinner-border text-secondary" role="status">
      <span class="visually-hidden">Подбираем сочетания...</span>
    </div>
  </div>
</template>

<script>
import RecipeCardPopular from "./RecipeCardPopular.vue";

export default {
  name: "RecipeCompanions",
  components: {
    RecipeCardPopular,
  },
  props: {
    recipeId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      sideDishes: [],
      companions: [],
      isLoading: false,
      error: null,
    };
  },
  watch: {
    recipeId: {
      immediate: true,
      handler(newId) {
        if (newId) {
          this.fetchCompanions(newId);
        }
      },
    },
  },
  methods: {
    async fetchCompanions(recipeId) {
      this.isLoading = true;
      this.error = null;
      this.sideDishes = [];
      this.companions = [];
      try {
        const command = `recipe.getCompanions/${recipeId}`;
        const response = await this.sendCmd(command);
        const data = JSON.parse(response);
        this.sideDishes = data.side_dishes || [];
        this.companions = data.companions || [];
      } catch (err) {
        this.error = "Не удалось загрузить сочетания блюд.";
        console.error("Error fetching recipe companions:", err);
      } finally {
        this.isLoading = false;
      }
    },
    handleShowFullRecipe(recipe) {
      window.location.hash = `/recipes/${recipe.id}`;
    },
  },
};
</script>

<style scoped>
.recipe-companions-container {
  padding-top: 1rem;
  border-top: 1px solid var(--bs-border-color-translucent);
}
.recipes-scroll-list {
  display: flex;
  overflow-x: auto;
  gap: 1rem;
  padding-bottom: 1rem; /* For scrollbar visibility */
  scrollbar-width: thin;
  scrollbar-color: var(--bs-secondary-bg) var(--bs-body-bg);
}

.recipes-scroll-list::-webkit-scrollbar {
  height: 8px;
}
.recipes-scroll-list::-webkit-scrollbar-thumb {
  background-color: var(--bs-secondary-bg);
  border-radius: 4px;
}
</style>
